import { useState, useEffect, useCallback } from "react";

interface UseRequestProps {
  request: (
    // eslint-disable-next-line no-unused-vars
    store: any,
    // eslint-disable-next-line no-unused-vars
    endpoint: string,
    // eslint-disable-next-line no-unused-vars
    method: string,
    // eslint-disable-next-line no-unused-vars
    args?: any,
    // eslint-disable-next-line no-unused-vars
    headers?: any,
    // eslint-disable-next-line no-unused-vars
    appendStringArgs?: any
  ) => Promise<any>;
  store: any;
  url: string;
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  data?: any;
  shouldFetchOnInit?: boolean;
  initialLoadingState?: boolean;
  headers?: any;
  // eslint-disable-next-line no-unused-vars
  onSuccess?: (data: any) => void;
  // eslint-disable-next-line no-unused-vars
  onError?: (error: any) => void;
}

export function useRequest({
  request,
  store,
  url,
  method,
  data,
  shouldFetchOnInit = false,
  initialLoadingState = false,
  headers,
  onSuccess,
  onError
}: UseRequestProps) {
  const [isLoading, setIsLoading] = useState<boolean>(initialLoadingState ?? false);
  const [error, setError] = useState<any>(null);

  const makeRequest = useCallback(
    async (dataOverride?: any) => {
      setError(null);
      setIsLoading(true);
      try {
        const result = await request(store, url, method, dataOverride ?? data, headers);
        if (result.ok) {
          onSuccess?.(result.data);
        } else {
          setError(result.error);
          onError?.(result.error);
        }
      } catch (err) {
        setError(err);
        onError?.(err);
      } finally {
        setIsLoading(false);
      }
    },
    [request, url, method, data, onSuccess, onError]
  );

  useEffect(() => {
    if (shouldFetchOnInit) {
      makeRequest(data);
    }
  }, [shouldFetchOnInit]);

  return { isLoading, error, makeRequest };
}
